"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _patchCart = _interopRequireDefault(require("../api-calls/patch-cart"));
var _getQueryKey = _interopRequireDefault(require("../get-query-key"));
var _getQueryKey2 = _interopRequireDefault(require("../../../../global-config/get-query-key"));
var _getQueryKey3 = _interopRequireDefault(require("../../../cart_reviews/v2/get-query-key"));
var _getQueryKey4 = _interopRequireDefault(require("../../../partner_cart_reviews/v1/get-query-key"));
var _getQueryKey5 = _interopRequireDefault(require("../../../partner_cart_reviews/v2/get-query-key"));
var _handleWarnings = _interopRequireDefault(require("../utils/handle-warnings"));
var _determineCartReviewsVersion = _interopRequireWildcard(require("../utils/determine-cart-reviews-version"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var getRemovePromotionCodeOptions = function getRemovePromotionCodeOptions(_ref) {
  var queryClient = _ref.queryClient;
  // Helper to get the appropriate query key based on cart reviews version
  var getCartReviewsQueryKeyForVersion = function getCartReviewsQueryKeyForVersion() {
    var globalConfig = queryClient.getQueryData((0, _getQueryKey2["default"])());
    var _ref2 = globalConfig || {},
      isGlobalStoreCountry = _ref2.isGlobalStoreCountry;
    var cartReviewsPath = (0, _determineCartReviewsVersion["default"])({
      isGlobalStoreCountry: isGlobalStoreCountry
    });
    if (cartReviewsPath === _determineCartReviewsVersion.CART_REVIEWS_V2) {
      return (0, _getQueryKey3["default"])();
    } else if (cartReviewsPath === _determineCartReviewsVersion.PARTNER_CART_REVIEWS_V2) {
      return (0, _getQueryKey5["default"])();
    } else if (cartReviewsPath === _determineCartReviewsVersion.PARTNER_CART_REVIEWS_V1) {
      return (0, _getQueryKey4["default"])();
    }
    // Fallback to cart_reviews as default
    return (0, _getQueryKey3["default"])();
  };
  return {
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref3) {
        var promotionCode;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              promotionCode = _ref3.promotionCode;
              return _context.a(2, (0, _patchCart["default"])({
                actions: [{
                  op: 'remove',
                  path: '/promotionCodes',
                  value: promotionCode
                }]
              }));
          }
        }, _callee);
      }));
      function mutationFn(_x) {
        return _mutationFn.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onMutate: function onMutate(_ref4) {
      var promotionCode = _ref4.promotionCode;
      // optimistically remove promo code from cartReviews
      var queryKey = getCartReviewsQueryKeyForVersion();
      queryClient.invalidateQueries(queryKey);
      queryClient.setQueryData(queryKey, function (cartReviews) {
        var _response$fulfillment, _currentFulfillmentGr, _response$promotionCo;
        if (!(cartReviews !== null && cartReviews !== void 0 && cartReviews.response)) {
          return cartReviews;
        }
        var response = cartReviews.response;
        var currentFulfillmentGroup = response === null || response === void 0 || (_response$fulfillment = response.fulfillmentGroups) === null || _response$fulfillment === void 0 ? void 0 : _response$fulfillment[0];

        // remove from cartReviews.response.fulfillmentGroups[0].items[$].itemCosts.promotionDiscounts[0]
        var itemsWithPromoCodesRemoved = (currentFulfillmentGroup === null || currentFulfillmentGroup === void 0 || (_currentFulfillmentGr = currentFulfillmentGroup.items) === null || _currentFulfillmentGr === void 0 ? void 0 : _currentFulfillmentGr.map(function (item) {
          var _item$itemCosts;
          var promotionDiscounts = ((_item$itemCosts = item.itemCosts) === null || _item$itemCosts === void 0 ? void 0 : _item$itemCosts.promotionDiscounts) || [];
          return _objectSpread(_objectSpread({}, item), {}, {
            itemCosts: _objectSpread(_objectSpread({}, item.itemCosts), {}, {
              promotionDiscounts: promotionDiscounts.filter(function (promoCode) {
                return promoCode.code !== promotionCode;
              })
            })
          });
        })) || [];
        return _objectSpread(_objectSpread({}, cartReviews), {}, {
          isPromosUpdating: true,
          response: _objectSpread(_objectSpread(_objectSpread({}, response), currentFulfillmentGroup && {
            fulfillmentGroups: [_objectSpread(_objectSpread({}, currentFulfillmentGroup), {}, {
              items: itemsWithPromoCodesRemoved
            })]
          }), {}, {
            // remove from cartReviews.response.promotionCodes
            promotionCodes: (_response$promotionCo = response.promotionCodes) === null || _response$promotionCo === void 0 ? void 0 : _response$promotionCo.filter(function (promoCode) {
              return promoCode.code !== promotionCode;
            })
          })
        });
      });
      return {
        meta: {
          dispatchCartUpdated: true
        }
      };
    },
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
        var _ref5,
          promotionCode,
          queryKey,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _ref5 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, promotionCode = _ref5.promotionCode;
              queryClient.setQueryData((0, _getQueryKey["default"])(), data);
              queryKey = getCartReviewsQueryKeyForVersion();
              queryClient.invalidateQueries({
                queryKey: queryKey
              });
              try {
                if (data !== null && data !== void 0 && data.id && promotionCode) {
                  window.webShellClient.analytics.trackAction({
                    underlyingAction: {
                      "case": 'coreCommerceV1CartModified',
                      value: {
                        cartId: data.id,
                        operation: {
                          "case": 'promoCodeRemoved',
                          value: {
                            value: promotionCode
                          }
                        }
                      }
                    }
                  });
                }
              } catch (e) {
                // Analytics failures must never interrupt promo removal UX.
              }

              // Handle warnings if present in the response
              if (!(data !== null && data !== void 0 && data.warnings && data.warnings.length > 0)) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return (0, _handleWarnings["default"])({
                warnings: data.warnings,
                data: data
              }, queryClient);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function onSuccess(_x2) {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  };
};
var _default = exports["default"] = getRemovePromotionCodeOptions;